import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Component } from "react";
import { func } from "prop-types";
import debounce from "lodash.debounce";
import { formFieldPropTypes } from "../../shared/propTypes";
export var NAME = "comment";
export var LABEL = "Comment";

var Comment = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Comment, _Component);

  function Comment(props) {
    var _this;

    _this = _Component.call(this, props) || this; // Set the initial value as whatever's in the canonical state

    _this.handleOnChange = function (e) {
      var value = e.target.value;

      _this.setState({
        value: value
      });

      _this.handleOnChangeDebounced(value);
    };

    _this.state = {
      value: props.comment.value
    };
    return _this;
  }

  var _proto = Comment.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var updateFormField = this.props.updateFormField;
    this.handleOnChangeDebounced = debounce(function (value) {
      updateFormField(NAME, {
        value: value,
        isTouched: true
      });
    }, 666);
  };

  _proto.render = function render() {
    var value = this.state.value;
    return /*#__PURE__*/React.createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-xs-5"
    }, /*#__PURE__*/React.createElement("label", {
      className: "control-label",
      htmlFor: NAME
    }, LABEL)), /*#__PURE__*/React.createElement("div", {
      className: "col-xs-7"
    }, /*#__PURE__*/React.createElement("textarea", {
      rows: 3,
      className: "form-control",
      name: NAME,
      onChange: this.handleOnChange,
      value: value
    })));
  };

  return Comment;
}(Component);

Comment.propTypes = {
  comment: formFieldPropTypes,
  updateFormField: func.isRequired
};
export { Comment as default };